import React, {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect
} from 'react';
import FlexSelect from 'components/Inputs/FlexSelect';
import { FaLink } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { custom_select } from 'assets/styles/multiple_select';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { useUsers } from '../../../../Report/Protocol/hooks/useUsers';
import DatePicker from '../../../../../components/Inputs/DatePicker';
import { ErrorFormMessage } from '../ErrorFormMessage';
import { functionsUseFul } from '../../assets/functionsUseFul';
import { ErrorMessage } from '@hookform/error-message';
import { useListReasonByRecordType } from '../../../../reason/list/hooks/useListReasonByRecordType';
import { useMultipleSubReason } from 'views/Report/Protocol/hooks/useMultipleSubReason';
import SelectAccount from 'react-select/async';
import { UserFlexSelect } from '../../../../../components/UserFlexSelect';
import { useSearchAccounts } from 'views/CRM/Account/hooks/useSearchAccounts';
import AdvancedSearch from 'views/Report/Protocol/Analytical/components/AdvancedSearchForm';
import { useProtocolFieldsByRecordType } from 'views/fieldConfigs/hooks/useProtocolFieldsByRecordType';
import { Controller, useForm } from 'react-hook-form';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';
import { formatCurrency } from 'utils/fuctions/formatCurrency';
import { maskPhoneNumber } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { maskCpf } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { maskCnpj } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import channels from 'variables/channels';
import { Row, Col, Input, Form } from 'reactstrap';
import { individual_column_style } from '../../../../../assets/styles/table_custom_style';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { useListStatusByRecordType } from '../../../../status/list/hooks/useListStatusByRecordType';
import { useHandleProtocolListing } from '../../hooks/useHandleProtocolListing';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import ReactLoader from 'components/Loader';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'components/Pagination';
import { useProtocolDefaultFieldsSettings } from '../../../../fieldConfigs/hooks/useProtocolDefaultFieldsSettings';
import { ProtocolNumberWrapper } from '../ProtocolNumberWrapper';
import { OutlineTooltip } from '../OutlineTooltip';
import { ClientNameWrapper } from '../ClientNameWrapper';
import ProtocolService from '../../../service';
import ServiceChannelService from '../../../../ServiceChannel/service';
const PAGE_SIZE = 10;

const AssociateToProtocolModal = ({
  selectedRecordTypeId,
  fatherProtocol,
  createdFrom,
  onModalToggle,
  onProtocolUpdate,
  ...props
}) => {
  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    errors,
    register,
    watch
  } = useForm();

  const [activePage, setActivePage] = useState(1);
  const { protocolDefaultFieldsDisplaySettings } =
    useProtocolDefaultFieldsSettings(selectedRecordTypeId);
  const { protocols, getProtocols, isLoadingProtocols, protocolsQuantity } =
    useHandleProtocolListing(selectedRecordTypeId);
  const [showDateIntervalForm, setShowDateIntervalForm] = useState(true);
  const [usersShowDisable, setUsersShowDisable] = useState(true);
  const { userList } = useUsers(usersShowDisable);
  const { getDateBegin, buildProtocolTitleString } = functionsUseFul();

  const { status, getStatusByRecordType } =
    useListStatusByRecordType(selectedRecordTypeId);
  const { reasons, getReasonsByRecordType } =
    useListReasonByRecordType(selectedRecordTypeId);
  const { subreasons, loadingSubreasons, handleGetSubReasons } =
    useMultipleSubReason();

  const [canalOptions, setCanalOptions] = useState([]);
  const [serviceChannelOptions, setServiceChannelOptions] = useState([]);

  const { isSearching, filterAccounts } = useSearchAccounts();

  const [account, setAccount] = useState();

  const [showAdvancedSearchForm, setShowAdvancedSearchForm] = useState(false);

  const [dataField, setDataField] = useState();
  const [rowsSelectds, setRowsSelectds] = useState([]);
  const [placement] = useState('bottom');

  const closeModal = props?.modalActions?.closeModal;

  useLayoutEffect(() => {
    const element = document.getElementById('fecharDynamicLayoutModal');
    if (element) {
      element.click();
    }
  }, []);

  const { protocolCustomFields } =
    useProtocolFieldsByRecordType(selectedRecordTypeId);

  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  useEffect(() => {
    getReasonsByRecordType();
  }, [getReasonsByRecordType]);

  useEffect(() => {
    getStatusByRecordType();
  }, [getStatusByRecordType]);

  const handleGetProtocols = useCallback(
    async (params = {}, showToastMessage = true) => {
      setDataField({ ...params });
      await getProtocols(params, showToastMessage);
    },
    [getProtocols]
  );

  const getChannels = useCallback(() => {
    FlexChatIntegration.getAllChannels().then((res) => {
      const info = res.data.data;

      let array = [];

      channels.forEach((nome) => {
        if (!info[nome]) return;
        if (nome === 'whatsapp') {
          info[nome].forEach((_, index) => {
            array.push(info[nome][index] ?? []);
          });
          return;
        }
        array.push(info[nome] ?? []);
      });

      const list = array.map((canal) => {
        return { label: canal?.nome_canal, value: canal?.id };
      });

      setCanalOptions(list);
    });
  }, [channels]);

  useEffect(() => {
    getChannels();
  }, [getChannels]);

  const getServiceChannels = useCallback(() => {
    ServiceChannelService.getWithoutPagination()
      .then((res) => {
        const data = res.data;
        const list = (Array.isArray(data) ? data : []).map((canal) => ({
          label: canal.name,
          value: canal.key
        }));
        setServiceChannelOptions(list);
      })
      .catch((err) => {
        console.error('Erro ao buscar canais:', err);
      });
  }, []);

  useEffect(() => {
    getServiceChannels();
  }, [getServiceChannels]);

  const onSubmit = async (dataSubmit) => {
    if (!selectedRecordTypeId) return;

    if (!showDateIntervalForm) {
      delete dataSubmit.dateBegin;
      delete dataSubmit.dateEnd;
    }

    if (account?.value) {
      dataSubmit.account_id = account?.value;
    }

    const dataDTO = formatCustomFieldsToSubmit(
      dataSubmit,
      protocolCustomFields ?? []
    );

    handleGetProtocols({ ...dataDTO, size: 10 }, false);
  };

  const handlePageChange = (activePage) => {
    setActivePage(activePage);
    getProtocols({
      ...(dataField || {}),
      page: activePage,
      size: 10
    });
  };

  const toISOFormat = useCallback(async (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${YYYY}/${MM}/${DD}`;
    return `${DD}/${MM}/${YYYY}`;
  }, []);

  const selectProtocol = {
    formatExtraData: rowsSelectds,

    style: individual_column_style,
    formatter: (_, row, _rowIndex, formatExtraData) => {
      const isChecked = formatExtraData.some((item) => item.id === row.id);
      return (
        <input
          checked={isChecked}
          onChange={(value) => {
            const id = row.id;
            const currentStatus = row.current_status;
            const number = row.number;
            const current_responsible = row.current_responsible;
            const account_id = row.account_id;
            const newItem = {
              id,
              currentStatus,
              number,
              current_responsible,
              account_id
            };

            if (value.target.checked && !isChecked) {
              const copy = [newItem];
              setRowsSelectds(copy);
            } else if (!value.target.checked && isChecked) {
              const copy = formatExtraData.filter((item) => item.id !== id);
              setRowsSelectds(copy);
            }
          }}
          value={row.id}
          type="checkbox"
        />
      );
    }
  };

  const createDynamicColumns = () => {
    const columns = [
      {
        dataField: 'number',
        text: 'Número',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          const showIcon = !!row?.parent_id || !!row?.subProtocols?.length;
          const { number, description } = row;
          return (
            <>
              {showIcon && <FaLink style={{ marginRight: '3px' }}></FaLink>}
              <ProtocolNumberWrapper
                number={number}
                description={description}
                isDescriptionShown={
                  protocolDefaultFieldsDisplaySettings &&
                  protocolDefaultFieldsDisplaySettings.description &&
                  protocolDefaultFieldsDisplaySettings.description.isRequired
                }
              />
            </>
          );
        }
      }
    ];

    columns.splice(0, 0, selectProtocol);
    if (
      protocolDefaultFieldsDisplaySettings &&
      Object.keys(protocolDefaultFieldsDisplaySettings).length
    ) {
      if (protocolDefaultFieldsDisplaySettings?.title?.isActive) {
        columns.push({
          dataField: 'title',
          text: 'Título',
          style: individual_column_style,
          // eslint-disable-next-line react/display-name
          formatter: (_, row) => {
            return (
              <>
                <div>
                  <span style={{}} id={`title-${row.id}`}>
                    {buildProtocolTitleString(row.title)}
                  </span>

                  <OutlineTooltip
                    placement={placement}
                    target={`title-${row.id}`}
                    message={row.title}
                  />
                </div>
              </>
            );
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        Object.keys(protocolDefaultFieldsDisplaySettings).length
      ) {
        if (protocolDefaultFieldsDisplaySettings.current_status?.isActive) {
          columns.push({
            dataField: 'status',
            text: 'Status/Fase',
            sort: true,
            style: individual_column_style,
            formatter: (_, row) => {
              const { nomeStatus, corStatus } = row;
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <>
                    <div
                      style={{
                        marginRight: '5px',
                        width: '12px',
                        height: '12px',
                        border: '1px solid #CDC9C9',
                        backgroundColor: `${corStatus}`
                      }}
                    ></div>
                    <div>{`${nomeStatus}`}</div>
                  </>
                </div>
              );
            }
          });
        }
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.client_id?.isActive
      ) {
        columns.push({
          dataField: 'cliente',
          text: 'Contato',
          style: individual_column_style,
          sort: true,
          formatter: (_, row) => {
            const { nomeCliente, telefoneCliente, emailCliente } = row;
            return (
              <ClientNameWrapper
                name={nomeCliente}
                telephone={telefoneCliente}
                email={emailCliente}
              />
            );
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.account_id?.isActive
      ) {
        columns.push({
          dataField: 'nomeConta',
          text: 'Conta',
          sort: true,
          style: individual_column_style,
          formatter: (_, row) => {
            const { nomeConta } = row;
            return nomeConta || '';
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.reason_id?.isActive
      ) {
        columns.push({
          dataField: 'nomeMotivo',
          text: 'Motivo',
          sort: true,
          style: individual_column_style
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.subreason_id?.isActive
      ) {
        columns.push({
          dataField: 'nomeSubmotivo',
          text: 'Submotivo',
          sort: true,
          style: individual_column_style
        });
      }

      columns.push({
        dataField: 'creation_date',
        text: 'Criação',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (!row.creation_date) {
            return '';
          }
          const date = new Date(row.creation_date);
          return `${date.toLocaleDateString(
            'pt-BR'
          )} às ${date.toLocaleTimeString('pt-BR', {
            timeZone: 'America/Fortaleza'
          })}`;
        }
      });

      columns.push({
        dataField: 'nomeResponsavel',
        text: 'Responsável',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          return row.nomeResponsavel || '';
        }
      });

      columns.push({
        dataField: 'last_change_date',
        text: 'Última Alteração',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          const date = new Date(row.last_change_date);
          return `${date.toLocaleDateString(
            'pt-BR'
          )} às ${date.toLocaleTimeString('pt-BR', {
            timeZone: 'America/Fortaleza'
          })}`;
        }
      });
    }

    (protocolCustomFields || []).forEach((field) => {
      columns.push({
        dataField: field.name,
        text: field.label,
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (field.type === 'DATE' && !!row[field.name]) {
            return new Date(row[field.name]).toLocaleDateString('pt-br');
          }

          if (field.type === 'CURRENCY' && !!row[field.name]) {
            return formatCurrency(row[field.name]);
          }

          if (field.type === 'TELEPHONE' && !!row[field.name]) {
            return maskPhoneNumber(row[field.name]);
          }

          if (field.type === 'CPF' && !!row[field.name]) {
            return maskCpf(row[field.name]);
          }

          if (field.type === 'CNPJ' && !!row[field.name]) {
            return maskCnpj(row[field.name]);
          }

          if (field.type === 'MULTIPLE' && !!row[field.name]) {
            return row[field.name].replace(/;/g, '; ');
          }

          return row[`${field.name}`];
        }
      });
    });

    return columns;
  };

  const dynamicFunctionColumns = createDynamicColumns();

  const associateProtocol = async () => {
    const updateId = rowsSelectds[0].id;

    if (updateId === createdFrom) {
      toast.error('Não é possível um protocolo se associar a ele mesmo', {
        autoClose: 3000,
        closeOnClick: true
      });
      return;
    }

    const dataDTO = {
      parentId: createdFrom || fatherProtocol.protocol.id,
      protocolId: updateId
    };

    await ProtocolService.updateParentProtocol(dataDTO);
    toast.success('Protocolo associado com sucesso', {
      autoClose: 3000,
      closeOnClick: true
    });
    onModalToggle(false);
    closeModal();
    if (onProtocolUpdate) {
      onProtocolUpdate();
    }
  };

  return (
    <>
      <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col md="6">
            <label className="form-control-label">Responsável atual</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={userList}
                  isMulti={true}
                  isClearable={true}
                  value={props.value}
                  closeMenuOnSelect={true}
                  valueController={setValue}
                  fieldName="current_responsible"
                  labelName="name"
                  valueName="login"
                />
              )}
              control={control}
              name="current_responsible"
              defaultValue=""
            />
          </Col>
        </Row>
        <Row className="mb-12">
          <Col className="md-12">
            <label
              className="form-control-label"
              style={{ marginLeft: '-15px' }}
            >
              <ToggleSwitch
                id="showDateForm"
                checked={showDateIntervalForm}
                onChange={() => {
                  setShowDateIntervalForm(!showDateIntervalForm);
                }}
                default={showDateIntervalForm}
              />
              Buscar por data
            </label>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="6">
            <label className="form-control-label">Data inicial</label>
            <Controller
              render={(props) => (
                <DatePicker
                  fieldName="dateBegin"
                  valueController={setValue}
                  defaultValue={props.value}
                  shouldDisable={!showDateIntervalForm}
                />
              )}
              control={control}
              name="dateBegin"
              defaultValue={getDateBegin()}
            />
            <ErrorMessage
              errors={errors}
              name="dateBegin"
              render={({ message }) => <ErrorFormMessage message={message} />}
            />
          </Col>
          <Col md="6">
            <label className="form-control-label">Data final</label>
            <Controller
              render={(props) => (
                <DatePicker
                  fieldName="dateEnd"
                  valueController={setValue}
                  defaultValue={props.value}
                  shouldDisable={!showDateIntervalForm}
                />
              )}
              control={control}
              name="dateEnd"
              defaultValue={new Date().toLocaleDateString('pt-br')}
              rules={{
                validate: async (value) => {
                  if (
                    new Date(await toISOFormat(value, true)) <
                    new Date(await toISOFormat(getValues()['dateBegin'], true))
                  ) {
                    return 'A data final não pode ser anterior à inicial!';
                  } else {
                    return true;
                  }
                }
              }}
            />
            <ErrorMessage
              errors={errors}
              name="dateEnd"
              render={({ message }) => <ErrorFormMessage message={message} />}
            />
          </Col>
          <Col className="mt-2" md="6">
            <label
              className="form-control-label"
              style={{ marginRight: '20px', fontWeight: '400' }}
            >
              <input
                type="radio"
                name="typeDateFilter"
                ref={register}
                value="creation"
                defaultChecked={true}
              />{' '}
              Data de criação
            </label>
            <label className="form-control-label" style={{ fontWeight: '400' }}>
              <input
                type="radio"
                name="typeDateFilter"
                ref={register}
                value="lastChange"
                defaultChecked={false}
              />{' '}
              Data de última alteração
            </label>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <label className="form-control-label">
              Número do protocolo, email, título, descrição ou telefone
            </label>
            <Controller
              as={
                <Input
                  type="text"
                  name="protocolTextQuery"
                  placeholder="Buscar por número do protocolo, título, descrição e telefone"
                />
              }
              control={control}
              name="protocolTextQuery"
              defaultValue=""
            />
          </Col>
          <Col md="6">
            <label className="form-control-label">
              Nome, email ou telefone do contato
            </label>
            <Controller
              as={
                <Input
                  type="text"
                  name="clientTextQuery"
                  placeholder="Buscar por Nome, email e telefone do contato"
                />
              }
              control={control}
              name="clientTextQuery"
              defaultValue=""
            />
          </Col>
        </Row>

        <Row>
          <Col className="mb-3" md="6">
            <label className="form-control-label">Motivo</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={
                    reasons
                      ? reasons.map(({ id, name }) => ({
                          label: name,
                          value: id
                        }))
                      : []
                  }
                  isMulti
                  value={props.value}
                  valueController={setValue}
                  fieldName="reason_id"
                  labelName="label"
                  valueName="value"
                  isClearable={true}
                  onChange={(e) => {
                    handleGetSubReasons(e);

                    if (e.length === 0) {
                      setValue('subreason_id', []);
                    }
                  }}
                />
              )}
              control={control}
              name="reason_id"
              defaultValue={[]}
            />
          </Col>
          <Col className="mb-3" md="6">
            <label className="form-control-label">Submotivo</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={
                    subreasons
                      ? subreasons.map(({ id, name }) => ({
                          label: name,
                          value: id
                        }))
                      : []
                  }
                  isMulti
                  value={props.value}
                  valueController={setValue}
                  fieldName="subreason_id"
                  labelName="label"
                  valueName="value"
                  isClearable={true}
                />
              )}
              disabled={loadingSubreasons}
              control={control}
              name="subreason_id"
              defaultValue={[]}
            />
          </Col>
          <Col className="mb-3" md="6">
            <label className="form-control-label">Status/Fase</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={
                    status
                      ? status.map(({ id, name }) => ({
                          label: name,
                          value: id
                        }))
                      : []
                  }
                  isMulti
                  value={props.value}
                  valueController={setValue}
                  fieldName="current_status"
                  labelName="label"
                  valueName="value"
                />
              )}
              control={control}
              name="current_status"
              defaultValue={[]}
            />
          </Col>
          <Col className="mb-3" md="6">
            <label className="form-control-label">Canal de atendimento</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={serviceChannelOptions}
                  value={props.value}
                  valueController={setValue}
                  fieldName="service_channel"
                  labelName="label"
                  valueName="value"
                  placeholder="Selecione o canal"
                  isSearchable={false}
                  isMulti
                  isClearable
                />
              )}
              control={control}
              name="service_channel"
              defaultValue=""
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="6">
            <label className="form-control-label">Canal</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={canalOptions}
                  isMulti={false}
                  isClearable={true}
                  value={props.value}
                  valueController={setValue}
                  closeMenuOnSelect={true}
                  fieldName="idChannel"
                  labelName="label"
                  valueName="value"
                />
              )}
              control={control}
              name="idChannel"
              defaultValue=""
            />
          </Col>

          <Col md="6">
            <label className="form-control-label">Conta</label>
            <SelectAccount
              styles={custom_select}
              placeholder="Buscar por conta"
              isClearable={true}
              name="account_id"
              isLoading={isSearching}
              loadingMessage={() => 'Buscando...'}
              noOptionsMessage={({ inputValue }) =>
                !inputValue
                  ? 'Digite para pesquisar'
                  : 'Nenhum resultado encontrado'
              }
              loadOptions={async (inputValue) => {
                const res = await filterAccounts(inputValue);
                return (
                  res &&
                  res.map((account) => ({
                    label: account.name,
                    value: account.id
                  }))
                );
              }}
              onChange={(data) => {
                if (data) {
                  const { value, label } = data;
                  setAccount({
                    label,
                    value
                  });
                } else {
                  setAccount(null);
                }
              }}
              value={
                account
                  ? {
                      label: account.label,
                      value: account.value
                    }
                  : ''
              }
              defaultValue={
                account
                  ? {
                      label: account.label,
                      value: account.value
                    }
                  : ''
              }
            />
          </Col>
        </Row>

        <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
          <UserFlexSelect
            usersShowDisable={usersShowDisable}
            setUsersShowDisable={setUsersShowDisable}
            name={'Responsável Atual'}
          />
        </div>
        <Row className="mb-12">
          <Col className="md-12">
            <label
              className="form-control-label"
              style={{ marginLeft: '-15px' }}
            >
              <ToggleSwitch
                checked={showAdvancedSearchForm}
                id="customFieldsAdvancedSearchForm"
                onChange={() => {
                  setShowAdvancedSearchForm(!showAdvancedSearchForm);
                }}
              />
              Busca avançada
            </label>
          </Col>
        </Row>
        {showAdvancedSearchForm && (
          <Row>
            <AdvancedSearch
              customFields={protocolCustomFields}
              control={control}
              setValue={setValue}
              error={errors}
              getValues={getValues}
              watch={watch}
              toISOFormat={toISOFormat}
            />
          </Row>
        )}

        <div className="mt-3">
          <Row>
            <Button
              style={buttonStyle(systemConfiguration.primary_color)}
              type="submit"
              size="md"
            >
              Filtrar protocolos
            </Button>
            {rowsSelectds.length > 0 && (
              <Button
                title="Associar a um protocolo"
                size="md"
                color="primary"
                onClick={() => associateProtocol()}
              >
                Associar protocolo
              </Button>
            )}
          </Row>
        </div>
      </Form>

      <Row>
        <Col>
          <>
            <ToolkitProvider
              data={protocols || []}
              keyField="id"
              loading={isLoadingProtocols}
              columns={dynamicFunctionColumns}
            >
              {(props) => (
                <div className="py-4 table-responsive">
                  {isLoadingProtocols ? (
                    <Row className="justify-content-md-center">
                      <ReactLoader />
                    </Row>
                  ) : (
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  )}
                </div>
              )}
            </ToolkitProvider>
            <Pagination
              activePage={activePage}
              itemsCountPerPage={PAGE_SIZE}
              totalItemsCount={protocolsQuantity}
              onChange={handlePageChange.bind(this)}
            />
          </>
        </Col>
      </Row>
    </>
  );
};

export default AssociateToProtocolModal;
